import React, { useEffect, useState } from 'react';
import images from '../../helpers/images';

import httpService from '../../helpers/httpService';

function Footer(){
    const [dswd, setDSWD] = useState('DSWD-SB-SP-00040-2021 valid from August 9, 2021 to August 10, 2022; Nationwide.')

    useEffect(() => {
        getDSWD()
    }, []);
    
    function getDSWD(){
        let resourceUrl = 'https://event-api.worldvision.org.ph/api/public/get-options?module=general&only=dswd';

        httpService.httpRequest(resourceUrl, "GET")
        .then((res) => {

            if(res.dswd){
                setDSWD(res.dswd)
            }
        })
        .catch((err) => {
        });        
    }

    return (
        <div id="footer-section">
            <div className="container">
                <div className="row">
                <div className="col-12">
                    <ul className="sm-icons">
                    <li><a href="http://bit.ly/wv-fb-page" target="_new"><img src={images.facebookIcon} alt="fb-icon" /></a></li>
                    <li><a href="http://twitter.com/worldvisionph" target="_new"><img src={images.twitterIcon} alt="twitter-icon" /></a></li>
                    <li><a href="http://www.youtube.com/user/worldvisionph" target="_new"><img src={images.youtubeIcon} alt="youtube-icon" /></a></li>
                    <li><a href="https://ph.linkedin.com/company/world-vision-philippines" target="_new"><img src={images.linkedinIcon} alt="linkedin-icon" /></a></li>
                    <li><a href="https://www.instagram.com/worldvisionphl/" target="_new"><img src={images.instagramIcon} alt="instagram-icon" /></a></li>
                    </ul>
                    <p>© Copyright {new Date().getFullYear()} World Vision Development Foundation, Inc <br /> {dswd}</p>
                </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;
